import { createContext, useState } from "react";

const DataContext = createContext({});
export const DataProvider = ({children}) => {
    const [lang, setLang] = useState(false);
    const [pos,setPos] = useState('home');
    return(
        <DataContext.Provider
            value={{lang,setLang,pos,setPos}}
        >
            {children}
        </DataContext.Provider>
    )
} 
export default DataContext;